import React, { Component } from "react";
import classNames from "classnames";

class NoticeList extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const noticeArray = this.props.noticeArray;
        const contentInfoClasses = classNames("content-info", {
            "no-icon": this.props.noIcon
        });

        return (
            <div className="notice-list">
                {noticeArray.map((item, idx) => {
                    return (
                        <div className={contentInfoClasses} key={idx}>
                            <div dangerouslySetInnerHTML={{ __html: item }} />
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default NoticeList;
